import { InputFormikField } from 'components/Forms/InputFormikField'
import { Form, Formik } from 'formik'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import toast, { Toaster } from 'react-hot-toast'

// crea un esquema de validación para el formulario usando Yup
import useContacts from 'components/Hooks/useContacts'
import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('El nombre es requerido')
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(50, 'El nombre debe tener menos de 50 caracteres'),
  number: Yup.string()
    .required('El número es requerido')
    .min(3, 'El número debe tener al menos 3 caracteres')
    .max(50, 'El número debe tener menos de 50 caracteres')
})

function AddContact ({ openModal, setOpenModal }) {
  const [buttonStatus, setButtonStatus] = React.useState(false)
  const { handleAddContact } = useContacts()
  const handleClose = () => setOpenModal(false)
  return (
    <>
      <Toaster />
      <Modal show={openModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Contacto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={validationSchema}
            initialValues={{
              name: '',
              number: '',
              grupos: []
            }}
            onSubmit={(values, { resetForm }) => {
              setButtonStatus(true)
              console.log(values)

              const data = {
                name: values.name,
                number: values.number
              }
              const results = handleAddContact(data)
              if (results) {
                toast.success('Contacto agregado con éxito')
                resetForm()
                setOpenModal(false)
              } else {
                toast.error('Error al agregar el contacto')
              }
            }}
          >
            {() => (
              <Form>
                <InputFormikField
                  label='Nombre'
                  name='name'
                  type='text'
                  placeholder='Nombre del Contacto'
                />
                <InputFormikField
                  label='Número'
                  name='number'
                  type='text'
                  placeholder='Numero de Telefono'
                />
                <Button variant='primary' type='submit' disabled={buttonStatus}>
                  Agregar
                </Button>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  )
}

export default AddContact
